var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('partner-table',{attrs:{"for_tennessee":_vm.for_tennessee},on:{"generatedPaymentOrder":function($event){return _vm.$emit('generatedPaymentOrder')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }